// extracted by mini-css-extract-plugin
module.exports = {"tags":"text,teal,aqua,pink,yellow,navy,light,sand,magenta,error,success,background,disabled,black,grey,white,copy"};